import React, { useState } from 'react';
import { TextField, Button, Typography, Container, Link, Alert, Paper, Box } from '@mui/material';
import { register } from '../api/auth';
import { useNavigate, Link as RouterLink } from 'react-router-dom';

const Register: React.FC<{ setIsLoggedIn: (value: boolean) => void, setUserName: (name: string) => void }> = ({ setIsLoggedIn, setUserName }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      const data = await register(name, email, password);
      localStorage.setItem('token', data.token);
      localStorage.setItem('userName', name);
      setIsLoggedIn(true);
      setUserName(name);
      navigate('/dashboard');
    } catch (error) {
      setError((error as Error).message);
    }
  };

  return (
    <Container maxWidth="xs">
      <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2, width: '100%', background: 'linear-gradient(135deg, #ffffff 0%, #f0f4f8 100%)' }}>
          <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ color: '#3a7bd5' }}>
            Register
          </Typography>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <form onSubmit={handleSubmit}>
            <TextField
              label="Name"
              fullWidth
              margin="normal"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
            />
            <TextField
              label="Email"
              type="email"
              fullWidth
              margin="normal"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
            />
            <TextField
              label="Password"
              type="password"
              fullWidth
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
            />
            <Button 
              type="submit" 
              variant="contained" 
              fullWidth 
              sx={{ 
                mt: 2, 
                mb: 2, 
                background: 'linear-gradient(to right, #3a7bd5, #00d2ff)',
                '&:hover': {
                  background: 'linear-gradient(to right, #3a7bd5, #3a7bd5)',
                },
              }}
            >
              Register
            </Button>
          </form>
          <Typography align="center">
            Already have an account? <Link component={RouterLink} to="/login" sx={{ color: '#3a7bd5' }}>Login</Link>
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default Register;